<template lang="html">
  <div class="project-item" :style="{ '--th': height + 'px' }">
    <router-link :to="{ name: 'project', params: { id: project.uid } }">
      <img v-lazy="project.cover" :alt="project.title" />
      <div ref="projectTitle" class="project-title">
        <txt :phrase="project.title" />
      </div>
    </router-link>
  </div>
</template>

<script>
const Txt = () =>
  import(/* webpackChunkName: "TableText" */ "@/components/TableText.vue");

export default {
  props: {
    project: Object
  },
  data() {
    return {
      height: null
    };
  },
  components: {
    Txt
  },
  mounted() {
    this.calcHeight();
    window.addEventListener("resize", this.calcHeight);
  },
  updated() {
    this.calcHeight();
  },
  methods: {
    calcHeight() {
      this.height = this.$refs.projectTitle.offsetHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
.project-item {
  overflow: hidden;
  position: relative;
  margin-bottom: calc(1 * var(--lh));
  a {
    display: inline-block;
    width: 100%;
  }
  img {
    transition: transform 0.5s;
  }
  .project-title {
    position: absolute;
    bottom: calc(0.25 * var(--lh));
    left: 0;
    display: block;
    z-index: -1;
    .phrase {
      display: block;
    }
  }
  &:hover {
    img {
      transform: translateY(calc((-1 * var(--th)) - (0.5 * var(--lh))));
    }
  }
}
</style>
